import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option:
      "a) Melhoria na compreensão de argumentos técnicos relevantes, gerando maior confiança e credibilidade junto aso stakeholders",
    correct: false,
  },
  {
    option:
      "b) Estratégia essencial para aprimorar habilidades e impulsionar o desempenho e resultados do negócio",
    correct: false,
  },
  {
    option: "c) Opção para aumentar os custos sem benefícios significativos",
    correct: false,
  },
  {
    option: "d) Alternativas A e B estão corretas",
    correct: true,
  },
];

export default function Question7(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question7: {
          title:
            "Qual das seguintes opções melhor expressa a importância de investir em treinamento e desenvolvimento?",
          option: option.option,
          correct: option.correct,
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        Qual das seguintes opções melhor expressa a importância de investir em
        treinamento e desenvolvimento?
      </h5>

      <div className="div-options-question-boe">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-boe ${
              optionSelected === e.option && "selected-option-question-boe"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
